





































































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import { IFilm } from "@/@types/cinema/films";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartCategoryName from "@/components/app/card/standart-category-name.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";

@Component({ components: { BSwitch, StandartCategoryName, BSettingDd } })
export default class MovieTableCard extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: Object, default: null }) movie!: IFilm;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Inject() readonly bgFolder!: string;

  get rk_color(): string {
    const rating = this.movie.ratings.ratingKinopoisk;
    if (!rating) return "";
    return rating > 7
      ? "#388e3c"
      : rating > 5
      ? "#f57f17"
      : rating > 2
      ? "#c62828"
      : "#263238";
  }

  get ri_color(): string {
    const rating = this.movie.ratings.ratingImdb;
    if (!rating) return "";
    return rating > 7
      ? "#388e3c"
      : rating > 5
      ? "#f57f17"
      : rating > 2
      ? "#c62828"
      : "#263238";
  }

  formatAgeLimit(val: string | null): string {
    if (!val) return "—";
    let clean = val.replace(/^age/i, "");
    if (/^\d+$/.test(clean)) clean += "+";
    return clean;
  }
}
